import './modules/_toggle-state';
import './modules/primary-header';
import './modules/slider';
import './modules/faq';
import './modules/toggle-question';
import './modules/slider-pagination';
import './modules/slider-corner';
import './modules/slider-product';
import './modules/recherche';
import './modules/text-animation';
import './modules/redirect-to';
import './modules/strate-produit';
import './modules/dropdown';
